import React from "react";

import {
  FaPen,
  FaTrash,
} from "react-icons/fa";

import EmptyState from "../ui/EmptyState";

import {
  ActorIdentity,
  ClubAndWish,
  ContactBlock,
  GroupBadges,
  LinkedUsers,
} from "./ActorCells";

export default function ActeursDesktopTable({
  rows,
  loading,
  deleting,

  onEdit,
  onDelete,
  onManageGroups,
  onCreate,
}) {
  return (
    <div className="hidden rounded-3xl border border-slate-200 bg-white shadow-sm xl:block dark:border-slate-800 dark:bg-slate-900">
      {loading ? (
        <div className="py-14 text-center text-sm text-slate-500">
          Chargement des acteurs...
        </div>
      ) : rows.length === 0 ? (
        <div className="p-6">
          <EmptyState
            onCreate={onCreate}
          />
        </div>
      ) : (
        <div className="overflow-x-auto rounded-3xl">
          <table className="w-full min-w-[1280px] table-fixed text-sm">
            <thead className="bg-slate-50 text-left dark:bg-slate-950/60">
              <tr className="text-slate-600 dark:text-slate-300">
                <th className="w-[18%] px-5 py-3 font-semibold">
                  Acteur
                </th>

                <th className="w-[16%] px-5 py-3 font-semibold">
                  Coordonnées
                </th>

                <th className="w-[18%] px-5 py-3 font-semibold">
                  Groupes
                </th>

                <th className="w-[16%] px-5 py-3 font-semibold">
                  Club / Souhait
                </th>

                <th className="w-[17%] px-5 py-3 font-semibold">
                  Compte utilisateur
                </th>

                <th className="w-[15%] px-5 py-3 font-semibold">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
              {rows.map((acteur) => (
                <tr
                  key={acteur.id}
                  className="align-top transition hover:bg-slate-50/80 dark:hover:bg-slate-800/40"
                >
                  <td className="px-5 py-4">
                    <ActorIdentity
                      acteur={acteur}
                    />
                  </td>

                  <td className="px-5 py-4">
                    <ContactBlock
                      acteur={acteur}
                    />
                  </td>

                  <td className="px-5 py-4">
                    <GroupBadges
                      groups={
                        acteur.Groups || []
                      }
                    />
                  </td>

                  <td className="px-5 py-4">
                    <ClubAndWish
                      acteur={acteur}
                    />
                  </td>

                  <td className="px-5 py-4">
                    <LinkedUsers
                      users={
                        acteur.Users || []
                      }
                    />
                  </td>

                  <td className="px-5 py-4">
                    <div className="flex flex-wrap gap-2">
                      <button
                        type="button"
                        onClick={() =>
                          onEdit(acteur)
                        }
                        className="inline-flex h-10 items-center gap-2 rounded-2xl bg-indigo-600 px-4 text-sm font-semibold text-white transition hover:bg-indigo-700"
                      >
                        <FaPen />
                        Éditer
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          onDelete(acteur.id)
                        }
                        disabled={deleting}
                        className="inline-flex h-10 items-center gap-2 rounded-2xl bg-red-600 px-4 text-sm font-semibold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
                      >
                        <FaTrash />
                        Supprimer
                      </button>

                      <button
                        type="button"
                        onClick={() =>
                          onManageGroups(
                            acteur,
                          )
                        }
                        className="inline-flex h-10 items-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
                      >
                        Groupes
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}